import React, { useState } from 'react';
import { Home } from './pages/Home';
import { UploadReceipt } from './pages/UploadReceipt';
import { History } from './pages/History';
import { Settings } from './pages/Settings';
import { Layout } from './components/Layout';
export function App() {
  const [currentScreen, setCurrentScreen] = useState('home');
  const [step, setStep] = useState(1);
  const [isChatOpen, setChatOpen] = useState(false);
  const navigateTo = (screen, stepValue = null) => {
    setCurrentScreen(screen);
    if (screen === 'upload') {
      setStep(stepValue || 1);
    }
  };
  const nextStep = () => {
    setStep(step + 1);
  };
  const prevStep = () => {
    setStep(Math.max(1, step - 1));
  };
  const openChat = () => setChatOpen(true);
  const closeChat = () => setChatOpen(false);
  return <>
      <Layout currentScreen={currentScreen} navigateTo={navigateTo} data-id="element-0">
        {currentScreen === 'home' && <Home navigateTo={navigateTo} data-id="element-1" />}
        {currentScreen === 'upload' && <UploadReceipt step={step} nextStep={nextStep} prevStep={prevStep} navigateTo={navigateTo} data-id="element-2" />}
        {currentScreen === 'history' && <History navigateTo={navigateTo} data-id="element-3" />}
        {currentScreen === 'settings' && <Settings navigateTo={navigateTo} data-id="element-4" />}
        <button onClick={openChat} className="fixed bottom-6 right-6 bg-blue-600 text-white px-4 py-2 rounded-full shadow" data-id="element-5">
          Assistant
        </button>
      </Layout>
      {isChatOpen && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={closeChat} data-id="element-6">
          <div className="relative w-full max-w-md h-4/5 bg-white rounded-lg shadow-lg" onClick={e => e.stopPropagation()} data-id="element-7">
            <button onClick={closeChat} className="absolute top-2 right-2 bg-gray-200 rounded-full p-1 hover:bg-gray-300" data-id="element-8">
              ✕
            </button>
            <iframe src="https://spaces.sprinklenet.com/chat?id=6872b2c60d4052fb0ee93307" className="w-full h-full border-none rounded-lg" data-id="element-9" />
          </div>
        </div>}
    </>;
}